import { SearchMenuEmptyState } from './SearchMenuEmptyState';
import { SearchableMenuErrorState } from './SearchableMenuErrorState';
/**
 * Component to display state for list items in a SearchableList
 */
export function SearchableMenuListState(props) {
    const { error = false, errorComponent, empty, emptyComponent, children } = props;
    if (error && errorComponent !== false) {
        return errorComponent || <SearchableMenuErrorState />;
    }
    if (empty) {
        if (emptyComponent === false) {
            return null;
        }
        return emptyComponent || <SearchMenuEmptyState />;
    }
    return children;
}
